import { setCartItems, setUserActionPayload, setIsCartUpdated } from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";

interface RemoveCartItemPayload {
  sku: string;
  currentPatientId: string;
  cartItems: CartItem[];
  dispatch: any;
}

export const removeCartItem = ({ sku, currentPatientId, cartItems, dispatch }: RemoveCartItemPayload) => {
  const itemToRemove = cartItems.find(({ sku: cartSku }) => cartSku === sku);

  if (itemToRemove) {
    if (currentPatientId) {
      dispatch(
        setUserActionPayload({
          medicineOrderCartLineItems: [
            {
              medicineSKU: sku,
              quantity: 0,
            },
          ],
        })
      );
    } else {
      const result = cartItems.filter((item) => item.sku !== sku);
      dispatch(setCartItems(result));
      dispatch(setIsCartUpdated(true));
    }
  }
};
